import classNames from 'classnames'
import {memo} from 'react'

import type {CategoryItem} from '../../Parameters.types'
import {getCategoryTitle} from '../../utils/getCategoryTitle'

import styles from './ParametersCategoryHeader.css'

interface Props {
  item: CategoryItem

  className?: string
}

function ParametersGroupHeaderComponent(props: Props) {
  return (
    <div role="rowheader" className={classNames(styles.categoryTitle, props.className)}>
      {getCategoryTitle(props.item.category)}
    </div>
  )
}

export const ParametersCategoryHeader = memo(ParametersGroupHeaderComponent)
